const parseNumber = (value) => {
  if (value === "") return null;
  // 移除非数字和小数点的字符
  const cleaned = value.replace(/[^\d.]/g, "");
  // 确保只有一个小数点
  const parts = cleaned.split(".");
  if (parts.length > 2) {
    return `${parts[0]}.${parts[1]}`;
  }
  return cleaned;
};

export default parseNumber;
